import { Enums } from "./enum";

const AUSTRALIA_BOUNDS = {
    latMin: -44,
    latMax: -10,
    lngMin: 113,
    lngMax: 154,
};

function isAustralianCoordinates(lat: number, lng: number): boolean {
    return (
        lat >= AUSTRALIA_BOUNDS.latMin &&
        lat <= AUSTRALIA_BOUNDS.latMax &&
        lng >= AUSTRALIA_BOUNDS.lngMin &&
        lng <= AUSTRALIA_BOUNDS.lngMax
    );
}

export function getRegionFromCoordinates(lat: number, lng: number): Enums.Region {
    return isAustralianCoordinates(lat, lng) ? Enums.Region.Australia : Enums.Region.UsWest;
}

export function detectRegionFromGeolocation(): Promise<Enums.Region | null> {
    return new Promise((resolve) => {
        if (!navigator.geolocation) {
            resolve(Enums.Region.UsWest);
            return;
        }

        navigator.geolocation.getCurrentPosition(
            (position) => {
                resolve(getRegionFromCoordinates(
                    position.coords.latitude,
                    position.coords.longitude,
                ));
            },
            () => resolve(null),
        );
    });
}
